import React from "react"
import styles from "./styles.css"
import PropTypes from "prop-types"

const TitleLabel = ({ children }) => {
  return <div className={styles.title}>{children}</div>
}

TitleLabel.propTypes = {
  children: PropTypes.node
}

export default TitleLabel



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/Inputs/TitleLabel/index.js